export const MAX_ROOM_ID_LENGTH = 10;
